import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InnerPage.css';

export default function TermsPage() {
      const { t } = useLanguage();
      
      useEffect(() => {
            window.scrollTo(0, 0);
      }, []);

      return (
            <div className="inner-page">
                  <Navbar />

                  <section className="inner-page__hero">
                        <div className="inner-page__hero-inner">
                              <div className="inner-page__tag">{t('terms.tag')}</div>
                              <h1 className="inner-page__title">{t('terms.title')}</h1>
                              <p className="inner-page__subtitle">
                                    {t('terms.subtitle')}
                              </p>
                        </div>
                  </section>

                  <div className="inner-page__content">

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.section1Title')}</h2>
                              <p>{t('terms.section1Text')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.section2Title')}</h2>
                              <p>{t('terms.section2Text')}</p>
                              <ul style={{ color: 'var(--text-light)', lineHeight: '1.7', marginBottom: '16px', listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>{t('terms.section2List1')}</li>
                                    <li>{t('terms.section2List2')}</li>
                                    <li>{t('terms.section2List3')}</li>
                                    <li>{t('terms.section2List4')}</li>
                              </ul>
                              <p>{t('terms.section2Text2')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.section3Title')}</h2>
                              <p>{t('terms.section3Text1')}</p>
                              <p>{t('terms.section3Text2')}</p>
                              <ul style={{ color: 'var(--text-light)', lineHeight: '1.7', listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>{t('terms.section3List1')}</li>
                                    <li>{t('terms.section3List2')}</li>
                              </ul>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.section4Title')}</h2>
                              <p>{t('terms.section4Text1')}</p>
                              <p>{t('terms.section4Text2')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.section5Title')}</h2>
                              <p>{t('terms.section5Text')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('terms.contactTitle')}</h2>
                              <p>{t('terms.contactText')}</p>
                              <a href="mailto:admin@agrollama.com" className="contact-highlight" id="terms-contact-email">
                                    {t('terms.contactEmail')}
                              </a>
                        </div>

                  </div>

                  <Footer />
            </div>
      );
}
